// extracted by mini-css-extract-plugin
export default {"AdmissionFAQ":"AdmissionFAQ_AdmissionFAQ__H+DvF","Container":"AdmissionFAQ_Container__KYWwd","Heading":"AdmissionFAQ_Heading__0xQCO","Para":"AdmissionFAQ_Para__uF5Mw"};